import { DrillDirectionEvent } from "./events/drill.direction.event";
import { Injectable } from "@angular/core";
import { SimpleChipExpression } from "@nrwl/query-emitter";
import { StateChipExpression } from "./common.data.types";

@Injectable()
export class DrillDirectionEventProvider {
  constructor() {}

  newMultiSearchEvent(chipExpressions: Array<SimpleChipExpression>): DrillDirectionEvent {
    return new DrillDirectionEvent('new', chipExpressions);
  }

  newSearchEvent(keyword, value): DrillDirectionEvent {
    return new DrillDirectionEvent('new', [new SimpleChipExpression(keyword, '=', [value])]);
  }

  resetSearchEvent(): DrillDirectionEvent {
    return new DrillDirectionEvent('reset', null);
  }

  appendSearchEvent(keyword, value): DrillDirectionEvent {
    return new DrillDirectionEvent('append', [new SimpleChipExpression(keyword, '=', [value])]);
  }

  appendReadOnlyEvent(keyword, value): DrillDirectionEvent {
    return new DrillDirectionEvent('readonly', [new StateChipExpression(keyword, '=', [value], true)]);
  }
}
